import './style.scss';

const Loading = ({ style }) => {
  return (
    <div className="center_body" style={style}>
      <div className="loader_square">
        <div className="first" />
        <div className="second" />
        <div className="third" />
        <div className="fourth" />
      </div>
    </div>
  );
};

export default Loading;
